import { h, Component } from "preact";

import Program from "../Program";
import { selectAlternativePrograms } from "../../utils";
import styles from './style.css'

class AlternativeProgramList extends Component {

    render() {
        let { formData, programs } = this.props;
        if (Object.keys(formData).length === 0) {
            return '';
        }
        let alternativePrograms = selectAlternativePrograms(formData, programs);
        if ( alternativePrograms.length === 0 ) {
            return '';
        }
        return (
            <div class={styles.altProgramList}>
                <h2 class="section-header"><span>Other transportation options</span></h2>
                <div class="section-headlines">
                    <p>The following transportation programs can help you get around.</p>
                </div>
                {alternativePrograms.map(program => {
                    return (
                        <Program
                            programData={program}
                            key={program.route_long_name}
                        />
                    );
                })}
            </div>
        );
    }
}

export default AlternativeProgramList;